import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer } from "react-leaflet";

const WORLD = [[-60, -170], [75, 175]];

export const GbifMap = ({ taxonKey, country, bbox, style = "classic.poly", testid, height = "aspect-square" }) => {
  const bounds = bbox ? [[bbox[0], bbox[2]], [bbox[1], bbox[3]]] : WORLD;
  const q = `taxonKey=${taxonKey}${country ? `&country=${country}` : ""}&bin=hex&hexPerTile=${country ? 40 : 60}&style=${style}`;
  return (
    <div data-testid={testid} data-country={country || ""} className={`isolate relative rounded overflow-hidden border bg-[#0d1b2a] ${height}`}>
      <MapContainer key={`${taxonKey}-${country}-${bbox}`} bounds={bounds} scrollWheelZoom={false} zoomSnap={0.25} worldCopyJump className="absolute inset-0 h-full w-full" style={{ background: "#0d1b2a" }}>
        <TileLayer url="https://tile.gbif.org/3857/omt/{z}/{x}/{y}@1x.png?style=gbif-dark" tileSize={512} zoomOffset={-1} attribution="GBIF, OpenMapTiles © OSM" />
        <TileLayer url={`https://api.gbif.org/v2/map/occurrence/density/{z}/{x}/{y}@1x.png?${q}`} tileSize={512} zoomOffset={-1} />
      </MapContainer>
    </div>
  );
};
